export enum GridFilterOperatorNameEnum {
  equalOperator = 'filter.eqOperator',
  isEmptyOperator = 'Is Empty',
  isNotEmptyOperator = 'Is Not Empty',
  notEqOperator = 'filter.notEqOperator',
  likeOperator = 'Like',
  notLikeOperator = 'Not Like',
  startsWithOperator = 'Starts with',
  notStartsWithOperator = 'Not starts with',
  inOperator = 'is one of',
  notinOperator = 'is not one of',

  afterOperator = 'filter.afterOperator',
  afterOrEqualOperator = 'filter.afterOrEqualOperator',
  beforeOrEqualOperator = 'filter.beforeOrEqualOperator',
  beforeOperator = 'filter.beforeOperator',
  gtOperator = 'is greater than',
  gteOperator = 'is greater or equal',
  ltOperator = 'is less than',
  lteOperator = 'is less or equal',
}

export enum GridFilterOperatorEnum {
  equalOperator = '==',
  notEqOperator = '!=',
  likeOperator = 'like',
  notLikeOperator = 'notlike',

  isEmptyOperator = 'isempty',
  isNotEmptyOperator = 'isnotempty',

  startsWithOperator = 'starts',
  notStartsWithOperator = 'notstarts',
  in = 'in',
  notin = 'notin',
  afterOperator = '>',
  afterOrEqualOperator = '>=',
  beforeOrEqualOperator = '<=',
  beforeOperator = '<',
}
